import React from 'react';
import moment from 'moment';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';

import LibraryAddIcon from '@material-ui/icons/LibraryAdd';
import AddLocationIcon from '@material-ui/icons/AddLocation';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import AppContent from '../_Shared/Layout/AppContent';
import CreateModal from '../_Shared/CreateModal';
import Select from '../_Shared/SearchableDropdown';
import LayerComponent from './MediaPlan/LayerComponent';
import WebsiteComponent from './MediaPlan/WebsiteComponent';
import BudgetLineComponent from './MediaPlan/BudgetLineComponent';
import BudgetLineEditor from './MediaPlan/BudgetLineEditor';
import './MediaPlan/media-plan.css';

const defaultLayer = { name: '' }
const uuidv4 = require('uuid/v4');
const _ = require('lodash');
const currency = new Intl.NumberFormat('en-NZ', {
    style: 'currency',
    currency: 'NZD'
});

class CampaignMediaPlan extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            campaign: this.props.campaign,
            showCreateEditModal: false,
            showDeleteModal: false,
            layer: defaultLayer,
            budgetLine: null,
            anchorEl: null,
            anchorElBudgetLine: null,
            budgetLineColumns: [{ field: 'format', label: 'Details' }, { field: 'buyType', label: 'Buy Type' }, 
            { field: 'startDate', label: 'Start Date', numeric: true }, { field: 'endDate', label: 'End Date', numeric: true }, 
            { field: 'estimatedUnits', label: 'Estimated Units', numeric: true }, { field: 'budget', label: 'Budget', numeric: true }, 
            { field: 'clientBudget', label: 'Client Budget', numeric: true }],
            value: 'delete',
            layersFiltered: [],
            layerId: ''
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { campaign } = this.props;
        if (campaign !== null && !_.isEqual(prevProps.campaign, campaign)) {
            this.setState({ campaign });
        }
    }

    toggleRowMenuLayer = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeLayerToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleRowMenuBudgetLine = currentTarget => {
        this.setState((prevState) => {
            return { anchorElBudgetLine: prevState.anchorElBudgetLine === currentTarget ? null : currentTarget }
        })
    }

    closeBudgetLineToggleRowMenu = () => {
        this.setState({ anchorElBudgetLine: null });
    }

    toggleCreateEditModal = e => {
        const { showCreateEditModal } = this.state;
        this.setState({ showCreateEditModal: !showCreateEditModal, layer: defaultLayer, isUpdate: false });
    }

    toggleEditModal = e => {
        const { layer, showCreateEditModal } = this.state;
        this.setState({ showCreateEditModal: !showCreateEditModal, layer: layer, isUpdate: true });
    }

    toggleDeleteModal = e => {
        const { campaign, layer, showDeleteModal } = this.state;
        this.setState({ 
            showDeleteModal: !showDeleteModal, 
            layersFiltered: campaign.layers.filter(x => x.id !== layer.id),
            anchorEl: null
        });
    }

    handleInputChange = (name, value) => {
        this.setState((prevState, state) => {
            return { layer: Object.assign({}, prevState.layer, { [name]: value }) }
        });
    }

    selectLayerElement = (layer, selectedIndex) => {
        this.setState({ layer, selectedIndex });
    }

    selectBudgetLineElement = (budgetLine, selectedIndex) => {
        const { campaign: { budgetLines } } = this.state;
        let budgetLineSelected = budgetLines.find(x => x.id === budgetLine.id);
        this.setState({ budgetLineSelected, selectedIndex });
    }

    closeBudgetLineEditor = budgetLine => {
        if (budgetLine !== null) { }
        this.setState({ budgetLine: null });
    }

    createOrUpdateLayer = e => {
        const { onCampaignUpdated } = this.props;
        const { layer, campaign, isUpdate, selectedIndex } = this.state;
        if(!isUpdate) {
            onCampaignUpdated(Object.assign({}, campaign, { layers: [...campaign.layers, Object.assign({}, layer, { id: uuidv4().replace(/-/g, '') })] }), 'add_layer');
        } else {
            let aux = Object.assign([], campaign.layers);
            aux.splice(selectedIndex, 1, layer);  
            onCampaignUpdated(Object.assign({}, campaign, { layers: aux }), 'update_layer');
        }
        this.toggleCreateEditModal(e); 
        this.setState({ anchorEl: null });
    }

    deleteLayer = (e) => {
        const { onCampaignUpdated, onBatchBudgetLinesUpdated, onBatchBudgetLinesDeleted } = this.props;
        const { campaign, layer, layerId } = this.state;

        let elems = campaign.budgetLines.filter(x => x.layerId === layer.id);

        if(elems.length > 0) {
            if(layerId !== '') {
                let budgetLinesToMove = [];            
                campaign.budgetLines.forEach(element => {
                    if(element.layerId === layer.id) {
                        let budgetLine = Object.assign({}, element, { layerId: layerId });
                        budgetLinesToMove.push(budgetLine);
                    }
                });
                onBatchBudgetLinesUpdated(budgetLinesToMove);
            } else {
                onBatchBudgetLinesDeleted(campaign.budgetLines.filter(x => x.layerId === layer.id));
            }
        }
        onCampaignUpdated(Object.assign({}, campaign, { layers: campaign.layers.filter(x => x.id !== layer.id) }), 'delete_layer');

        this.toggleDeleteModal(e);        
    }

    createBudgetLine = () => {
        this.setState((prevState, state) => {
            return {
                budgetLine: {
                    id: uuidv4().replace(/-/g, ''),
                    format: '',
                    buyType: 'cpm',
                    campaignId: prevState.campaign.id,
                    costModifier: prevState.campaign.advertiser.costModifier,
                    flights: [],
                    externalMaps: []
                },
                isUpdate: false
            }
        })
    }

    editBudgetLine = () => {
        const { budgetLineSelected } = this.state;
        this.setState({ budgetLine: budgetLineSelected, isUpdate: true, anchorElBudgetLine: null });
    }

    deleteBudgetLine = () => {
        const { onBudgetLineRemoved } = this.props;
        const { budgetLineSelected } = this.state;
        onBudgetLineRemoved(budgetLineSelected);
        this.setState({ budgetLineSelected: null, anchorElBudgetLine: null });
    }

    saveBudgetLine = (budgetLine) => {
        const { onBudgetLineAdded, onBudgetLineUpdated } = this.props;
        const { isUpdate } = this.state;

        if(isUpdate) { onBudgetLineUpdated(budgetLine); } 
        else { onBudgetLineAdded(budgetLine); }        
    }

    deleteExternalMap = (externalMap) => {
        const { onDeleteExternalMap } = this.props;
        onDeleteExternalMap(externalMap);
    }

    handleRadioChange = event => {
        this.setState({ value: event.target.value });
    };
    
    handleLayerIdChange = (value) => {
        this.setState({ layerId: value });
    }

    render() {
        const { loading, websites, websitesLoading, providers, providersLoading } = this.props;
        const { campaign, showCreateEditModal, showDeleteModal, layer, budgetLine, budgetLineColumns, anchorEl, anchorElBudgetLine, layersFiltered, layerId } = this.state;
        
        return (<AppContent>
                    <Grid container spacing={24}>
                    {
                        loading &&
                        <Grid container item spacing={24}><Grid item xs><LinearProgress variant="query" color="secondary" /></Grid></Grid>
                    }
                    </Grid>
                    <DataTableToolbar title={campaign.name + " Media Plan"} numSelected={0} >
                        <Tooltip title="Add New Layer">
                            <IconButton onClick={this.toggleCreateEditModal} color="secondary"><LibraryAddIcon /></IconButton>
                        </Tooltip>
                    {
                        campaign && campaign.layers && [].concat(campaign.layers).length > 0 &&
                        <Tooltip title="Add New Placement">
                            <IconButton onClick={this.createBudgetLine} color="secondary"><AddLocationIcon /></IconButton>
                        </Tooltip>
                    }
                    </DataTableToolbar>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell></TableCell>
                                {                            
                                    [].concat(budgetLineColumns).map((col, colIndex) => <TableCell numeric={col.numeric} key={`table_header_cell_${colIndex}`}>{col.label}</TableCell>)
                                }
                                <TableCell numeric>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        {
                            campaign && campaign.layers &&
                            [].concat(campaign.layers).map((layer, layerIndex) =>
                                <LayerComponent key={`table_layer_cell_${layerIndex}`} layer={layer} layerIndex={layerIndex} colSpan={budgetLineColumns.length} 
                                    toggleRowMenu={this.toggleRowMenuLayer} onElementSelect={this.selectLayerElement}>
                                    {
                                        layer && layer.websites &&
                                        [].concat(layer.websites).map((website, websiteIndex) =>
                                        {
                                            return <WebsiteComponent key={`table_layer_${layerIndex}_website_cell_${websiteIndex}`} columns={[{ field: 'name', label: 'Name' }]}
                                                colSpan={budgetLineColumns.length} website={website}>
                                                {
                                                    campaign && campaign.budgetLines &&
                                                    [].concat(campaign.budgetLines.filter(x => x.layerId === layer.id && x.websiteId === website.id)).map((placement, placementIndex) => {
                                                        let budget = placement.flights.map(f => f.budget).reduce((a, b) => a + b, 0);
                                                        const mediaLine = Object.assign({}, placement, {
                                                            startDate: moment.min(placement.flights.map(p => moment(p.startDate))).format('DD-MM-YYYY'),
                                                            endDate: moment.max(placement.flights.map(p => moment(p.endDate))).format('DD-MM-YYYY'),
                                                            budget: currency.format(budget),
                                                            clientBudget: currency.format(budget * placement.costModifier),
                                                            estimatedUnits: placement.flights.map(f => f.estimatedUnits).reduce((a, b) => a + b, 0)
                                                        });
                                                        return <BudgetLineComponent key={`table_layer_${layerIndex}_website_${websiteIndex}_cell_${placementIndex}`}
                                                                    budgetLine={mediaLine} columns={budgetLineColumns} websiteIndex={placementIndex} 
                                                                    toggleRowMenu={this.toggleRowMenuBudgetLine} onElementSelect={this.selectBudgetLineElement}>
                                                                    <Menu anchorEl={anchorElBudgetLine} open={Boolean(anchorElBudgetLine)} onClose={this.closeBudgetLineToggleRowMenu}>
                                                                        <MenuItem onClick={this.editBudgetLine}>
                                                                            <ListItemIcon><EditIcon /></ListItemIcon>
                                                                            <ListItemText inset primary="Settings" />
                                                                        </MenuItem>
                                                                        <Divider />   
                                                                        <MenuItem onClick={this.deleteBudgetLine}>
                                                                            <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                                                                            <ListItemText inset primary="Delete" />
                                                                        </MenuItem>
                                                                    </Menu>
                                                                </BudgetLineComponent>;
                                                    })
                                                }
                                        </WebsiteComponent>})
                                    }                         
                                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={this.closeLayerToggleRowMenu}>
                                        <MenuItem onClick={this.toggleEditModal}>
                                            <ListItemIcon><EditIcon /></ListItemIcon>
                                            <ListItemText inset primary="Settings" />
                                        </MenuItem>
                                        <Divider />   
                                        <MenuItem onClick={this.toggleDeleteModal}>
                                            <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                                            <ListItemText inset primary="Delete" />
                                        </MenuItem>
                                    </Menu>
                                </LayerComponent>
                            )
                        }
                    </Table>
                    <CreateModal title="Create/Edit Campaign Layer" open={showCreateEditModal} closeHandler={this.toggleCreateEditModal} saveHandler={this.createOrUpdateLayer}>
                        <Grid container item spacing={24}>
                            <Grid item xs>
                                <TextField autoFocus value={layer.name} onChange={e => this.handleInputChange('name', e.target.value)}
                                    id="name" name="name" label="Layer Name" type="text" fullWidth />
                            </Grid>
                        </Grid>
                    </CreateModal>
                    <CreateModal title="Delete Campaign Layer" open={showDeleteModal} closeHandler={this.toggleDeleteModal} saveHandler={this.deleteLayer}>
                        <Grid container item spacing={24}>
                            <Grid item xs>
                                <RadioGroup value={this.state.value} onChange={this.handleRadioChange}>
                                    <FormControlLabel value="delete" control={<Radio />} label="Delete Budget Lines with it" />            
                                    <FormControlLabel value="assign" control={<Radio />} label="Assign Budget Lines to another layer" />
                                </RadioGroup>
                            </Grid>
                        </Grid>
                        <Grid container item spacing={24}>
                        {
                            this.state.value && this.state.value === 'assign' &&
                            <Grid item xs>
                                <Select options={[].concat(layersFiltered).map(x => { return { 'label': x.name, 'value': x.id } })} value={layerId} name="layerId" label="Layer"
                                    onChange={value => this.handleLayerIdChange(value)} placeholder="Please select a Layer" />
                            </Grid>
                        }
                        </Grid>
                    </CreateModal>
                    {
                        budgetLine && 
                        <BudgetLineEditor campaign={campaign} websites={websites} websitesLoading={websitesLoading} providers={providers} 
                            providersLoading={providersLoading} budgetLine={budgetLine} onClose={this.closeBudgetLineEditor} 
                            onBudgetLineAdded={this.saveBudgetLine} onDeleteExternalMap={this.deleteExternalMap} />
                    }
                </AppContent >)
    }
}

export default CampaignMediaPlan;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Campaigns/CampaignMediaPlan.js